import { Lightning, Router, Utils } from "@lightningjs/sdk";
import { FOCUS_TRANSITION } from "./focus";
export class Card extends Lightning.Component {
    constructor() {
        super(...arguments);
        this._description = "";
        this._duration = "";
        this._href = "";
        this._posterSrc = "";
        this._showDescription = true;
    }
    static _template() {
        const durationFontSize = 18.04;
        const durationLineHeight = durationFontSize * 1.29;
        return {
            h: this.H_NO_DESC,
            w: this.W,
            PosterContainer: {
                h: this.H_NO_DESC,
                w: (w) => w,
                clipping: true,
                renderToTexture: true,
                color: 0x00000000,
                rect: true,
                shader: {
                    type: Lightning.shaders.RoundedRectangle,
                    radius: this.BORDER_R,
                },
                Poster: {
                    h: this.H_NO_DESC,
                    w: (w) => w,
                    texture: {
                        type: Lightning.textures.ImageTexture,
                    },
                },
                Gradient: {
                    h: this.H_NO_DESC,
                    w: (w) => w,
                    src: Utils.asset("images/gradient.png"),
                    visible: false,
                },
                Duration: {
                    x: (w) => w - 22,
                    y: 10,
                    mountX: 1,
                    visible: false,
                    flex: { padding: 6 },
                    Background: {
                        w: (w) => w,
                        h: (h) => h,
                        flexItem: false,
                        rect: true,
                        color: 0xff1e0046,
                        alpha: 0.5,
                        shader: {
                            type: Lightning.shaders.RoundedRectangle,
                            radius: 8,
                        },
                    },
                    Label: {
                        text: {
                            fontFace: "Lato",
                            fontStyle: "400",
                            fontSize: durationFontSize,
                            lineHeight: durationLineHeight,
                            h: durationLineHeight,
                            textColor: 0xffffffff,
                            wordWrap: false,
                        },
                    },
                },
                Border: {
                    alpha: 0,
                    zIndex: 1,
                    color: this.BORDER_COLOR,
                    texture: this.borderTexture(this.W, this.H_NO_DESC),
                },
            },
            Description: {
                y: 189,
                text: {
                    advancedRenderer: true,
                    fontFace: "Roboto",
                    fontSize: 24,
                    precision: 1,
                    fontStyle: "500",
                    lineHeight: 28,
                    maxLines: 2,
                    maxLinesSuffix: "...",
                    wordWrap: true,
                    wordWrapWidth: this.W,
                },
            },
        };
    }
    static get height() {
        return this.H;
    }
    static borderTexture(w, h, radius = this.BORDER_R, borderWidth = this.BORDER_W) {
        return Object.assign(Object.assign({}, Lightning.Tools.getRoundRect(w - borderWidth, h - borderWidth, radius - borderWidth / 2, borderWidth, 0xffffffff, false)), { 
            // Crop the helper's 1px padding to keep the stroke inside the image.
            x: 1, y: 1, w,
            h });
    }
    static get marginRight() {
        return 20;
    }
    static get width() {
        return this.W;
    }
    set description(description) {
        this._description = description !== null && description !== void 0 ? description : "";
        this._updateTemplate();
    }
    set showDescription(showDescription) {
        this._showDescription = showDescription !== null && showDescription !== void 0 ? showDescription : true;
        this._updateTemplate();
    }
    set duration(duration) {
        var _a;
        this._duration = (_a = duration === null || duration === void 0 ? void 0 : duration.trim()) !== null && _a !== void 0 ? _a : "";
        this._updateTemplate();
    }
    set href(href) {
        this._href = href !== null && href !== void 0 ? href : "";
    }
    set posterSrc(posterSrc) {
        this._posterSrc = posterSrc;
        this._updateTemplate();
    }
    set posterCrop(posterCrop) {
        this.patch({
            PosterContainer: {
                Poster: {
                    texture: posterCrop !== null && posterCrop !== void 0 ? posterCrop : { x: 0, y: 0, w: 0, h: 0 },
                },
            },
        });
    }
    set preview(preview) {
        this._preview = preview;
    }
    set showGradient(showGradient) {
        this.patch({
            PosterContainer: {
                Gradient: {
                    visible: showGradient !== null && showGradient !== void 0 ? showGradient : false,
                },
            },
        });
    }
    _focus() {
        this.patch({
            PosterContainer: {
                Border: {
                    smooth: {
                        alpha: [1, FOCUS_TRANSITION],
                    },
                },
            },
        });
    }
    _handleEnter() {
        if (this._href) {
            Router.navigate("video", Object.assign({ href: this._href, title: this._description, category: this.fireAncestors("$getPlaybackCategory") || "Highlights" }, (this._preview && { preview: this._preview })));
        }
    }
    _unfocus() {
        this.patch({
            PosterContainer: {
                Border: {
                    smooth: {
                        alpha: [0, FOCUS_TRANSITION],
                    },
                },
            },
        });
    }
    _updateTemplate() {
        this.patch({
            h: this._showDescription && this._description ? Card.H : Card.H_NO_DESC,
            Description: {
                visible: this._showDescription,
                text: {
                    text: this._description,
                },
            },
            PosterContainer: {
                Duration: {
                    visible: this._duration.length > 0,
                    Label: {
                        text: {
                            text: this._duration,
                        },
                    },
                },
                Poster: {
                    texture: {
                        src: this._posterSrc,
                    },
                },
            },
        });
    }
}
Card.BORDER_COLOR = 0xffffffff;
Card.BORDER_R = 30;
Card.BORDER_W = 3;
Card.H = 245;
Card.H_NO_DESC = 181;
Card.W = 322;
export default Card;
//# sourceMappingURL=Card.js.map